import { computed, type Ref, toValue, type WritableComputedRef } from 'vue'
import { clamp, type RefOrGetter } from '@/helpers'
import type { InputRangeModel } from '@/components/ui/inputs/range/input-range-two-knobbed-props.ts'

type InputRangeModels = {
    min: WritableComputedRef<number, number>
    max: WritableComputedRef<number, number>
}

export function useInputRangeModels(
    model: RefOrGetter<InputRangeModel>,
    min: Ref<number>,
    max: Ref<number>,
    update: (model: InputRangeModel) => void
): InputRangeModels {
    return {
        min: computed({
            get() {
                return clamp(
                    toValue(model)[0] ?? min.value,
                    min.value,
                    max.value
                )
            },
            set(val: number) {
                update(sortModel([val, toValue(model)[1] ?? max.value]))
            },
        }),
        max: computed({
            get() {
                return clamp(
                    toValue(model)[1] ?? max.value,
                    min.value,
                    max.value
                )
            },
            set(val: number) {
                update(sortModel([toValue(model)[0] ?? min.value, val]))
            },
        }),
    }
}

function sortModel(model: [number, number]): [number, number] {
    return model.sort((a, b) => {
        return a - b
    })
}
